import { Table, TableContainer } from '@mui/material'
import NoDataBlock from 'components/farm/shared/NoDataBlock'
import { Dispatch, SetStateAction } from 'react'
import TableSkeleton from 'ui/skeleton/TableSkeleton'
import { SortOrderings } from '../types'

import { COLORS } from 'styles/colors'
import { IMilkingCowItem } from './IMilkingTableResponse'
import { YieldTableBody } from './YieldTableBody'
import { YieldTableHead } from './YieldTableHead'

interface YieldTableProps {
	data: IMilkingCowItem[]
	setSortOrder: Dispatch<SetStateAction<SortOrderings>>
	sortOrder: SortOrderings | null
	isLoading: boolean
	undigitizedTags?: Set<string>
	undigitizedCollars?: Set<string>
}

const YieldTable = ({
	data,
	isLoading,
	setSortOrder,
	sortOrder,
	undigitizedTags,
	undigitizedCollars,
}: YieldTableProps) => {
	if (isLoading) {
		return (
			<TableSkeleton
				widthForBody='100%'
				heightForBody='34px'
				rowCount={36}
				totalHeight='calc(100vh - 350px)'
			/>
		)
	}

	if (!isLoading && data?.length === 0) {
		return <NoDataBlock margin={'100px 0'} />
	}

	return (
		<TableContainer
			sx={{
				overflowY: 'auto',
				overflowX: 'hidden',
				height: 'calc(100vh - 350px)',
				'&::-webkit-scrollbar': { width: 4 },
				'&::-webkit-scrollbar-track': {
					backgroundColor: '#DBDBDB',
					borderRadius: 12,
				},
				'&::-webkit-scrollbar-thumb': {
					backgroundColor: COLORS.icon,
					borderRadius: 12,
				},
			}}
		>
			<Table
				sx={{
					'& .MuiTableCell-root:first-of-type': {
						paddingLeft: 0,
					},
				}}
			>
				<YieldTableHead setSortOrder={setSortOrder} sortOrder={sortOrder} />
				<YieldTableBody
					data={data}
					undigitizedTags={undigitizedTags}
					undigitizedCollars={undigitizedCollars}
				/>
			</Table>
		</TableContainer>
	)
}

export default YieldTable
